<button mat-stroked-button [matMenuTriggerFor]="menu" [class]="class">
	<div class="inner-button">
		<span>{{text}}</span>
		<mat-icon [inline]="true">keyboard_arrow_down</mat-icon>
	</div>
</button>

<mat-menu #menu="matMenu">
	<button (click)="onStatusChange.emit(AppointmentStatus.Scheduled)" mat-menu-item>Scheduled</button>
	<button (click)="onStatusChange.emit(AppointmentStatus.Arrived)" mat-menu-item>Arrived</button>
	<button (click)="onStatusChange.emit(AppointmentStatus.CheckedIn)" mat-menu-item>Checked In</button>
	<button (click)="onStatusChange.emit(AppointmentStatus.InVisit)" mat-menu-item>In Visit</button>
	<button (click)="onStatusChange.emit(AppointmentStatus.CheckedOut)" mat-menu-item>Checked Out</button>
</mat-menu>
